import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useStringFlagValue } from '#pplx/frontend/experimentation/hooks.js';
const DEFAULT_STAGE = 'legacy';
const KNOWN_STAGES = new Set([
    'legacy',
    'live_reads',
    'live_writes',
    'deferred_reductions',
]);
/**
 * Resolves the backend seat-capacity rollout stage from the shared flag.
 * Frontend and backend use different subjects, so Eppo rules must target the
 * shared `orgUUID` attribute rather than the subject ID.
 */
export function useEnterpriseSeatCapacityRolloutStage() {
    const { session, status } = useSession();
    const orgUUID = session?.user?.org_uuid;
    const hasOrgContext = Boolean(orgUUID && orgUUID !== 'none');
    const hasSubjectKey = Boolean(session?.user?.id);
    const { variation, loading } = useStringFlagValue({
        flag: 'enterprise-seat-capacity-rollout-stage',
        defaultValue: DEFAULT_STAGE,
        skip: !hasOrgContext || !hasSubjectKey,
    });
    return {
        stage: hasOrgContext && KNOWN_STAGES.has(variation) ? variation : DEFAULT_STAGE,
        loading: status === 'loading' || (hasOrgContext && hasSubjectKey && loading),
    };
}
//# sourceMappingURL=useEnterpriseSeatCapacityRolloutStage.js.map